/* eslint-disable react/static-property-placement */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { Component } from 'react';
import propTypes from 'prop-types';
import cx from 'classnames';
import FontFaceObserver from 'fontfaceobserver';
import invert from 'invert-color';
import NavigationBarItem from '../NavigationBarItem/NavigationBarItem';
import WithNavigation from '../../common/WithNavigation';
import {
  getFontNameFromGoogleFontUrl,
} from '../../../helpers/fonts';
import styles from './NavigationBar.scss';

class NavigationBar extends Component {
  static propTypes = {
    navigationBar: propTypes.shape({
      base64Logo: propTypes.string,
      backgroundColour: propTypes.string,
      rootUrl: propTypes.string,
      navigationBarItems: propTypes.array,
    }),
    isFontExisted: propTypes.bool,
    trackingPageFont: propTypes.shape({
      trackingPageFontProperties: propTypes.shape({
        name: propTypes.string,
        url: propTypes.string,
        size: propTypes.number,
        fontWeight: propTypes.string,
        colour: propTypes.string,
      }),
    }),
  };

  static defaultProps = {
    navigationBar: {},
    isFontExisted: false,
    trackingPageFont: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      navActive: false,
      uploadedNavigationBarFont: null,
    };
  }

  componentDidMount() {
    const { navigationBar: { font } } = this.props;
    if (font && font.url) {
      const fontFace = new FontFaceObserver(getFontNameFromGoogleFontUrl(font.url));
      fontFace.load(null, 6000).then((loadedFont) => this.setState({
        uploadedNavigationBarFont: loadedFont,
      }));
    }
  }

  renderNavigationBarItems = () => {
    const {
      navigationBar,
      isFontExisted,
      trackingPageFont: {
        trackingPageFontProperties,
        uploadedTrackingPageFont,
      },
    } = this.props;
    const { uploadedNavigationBarFont } = this.state;

    if (isFontExisted && ((navigationBar.font && navigationBar.font.url && !uploadedNavigationBarFont)
      || (!navigationBar.font && !uploadedTrackingPageFont))) {
      return '';
    }

    let selectedFont;
    if (isFontExisted && navigationBar.font && navigationBar.font.url && uploadedNavigationBarFont) {
      selectedFont = uploadedNavigationBarFont;
    } else if (isFontExisted && uploadedTrackingPageFont) {
      selectedFont = uploadedTrackingPageFont;
    }

    return navigationBar
    && navigationBar.navigationBarItems
    && navigationBar.navigationBarItems.map((navigationBarItem) => (
      <NavigationBarItem
        key={navigationBarItem.id}
        navigationBarItem={navigationBarItem}
        uploadedFont={selectedFont}
        fontStyles={navigationBar.font || trackingPageFontProperties}
      />
    ));
  };

  render() {
    const {
      navigationBar,
      navigationBar: {
        backgroundColour,
        borderColour,
        rootUrl,
        navigationBarItems,
      },
    } = this.props;

    const { navActive } = this.state;

    document.documentElement.style.setProperty('--nav-background', backgroundColour);
    document.documentElement.style.setProperty('--nav-border', borderColour);
    if (backgroundColour) {
      document.documentElement.style.setProperty(
        '--nav-item-color',
        invert(backgroundColour, true),
      );
    }

    return (
      <nav className={cx(styles.nav, navActive && styles.navActive)}>
        <div role="button" className={styles.navInner}>
          <div className={styles.navLogoContainer}>
            {navigationBar.base64Logo
            && (
            <WithNavigation url={rootUrl}>
              <img
                className={styles.navLogo}
                alt="logo"
                src={`data:image/png;base64,${navigationBar.base64Logo}`}
              />
            </WithNavigation>
            )}
          </div>
          {navigationBarItems && navigationBarItems.length > 0 ? (
            <div
              role="button"
              className={styles.navToggler}
              onClick={() => this.setState((prevState) => ({ navActive: !prevState.navActive }))}
            >
              <span />
              <span />
              <span />
            </div>
          ) : <div className={styles.navTogglerPlaceholder} />}
          <div className={styles.navItems}>
            {
              this.renderNavigationBarItems()
            }
          </div>
        </div>
      </nav>
    );
  }
}

export default NavigationBar;
